export default {
  noDataAvailable: 'Keine Daten verfügbar',
  dismiss: 'Ausblenden',
  timePicker: {
    hour: 'Stunde',
    minute: 'Minute',
    cancel: 'Abbrechen',
    apply: 'Übernehmen',
    clear: 'Löschen',
    oClock: 'Uhr',
  },
}
